export { on } from '../internal/client/dom/elements/events.js';
